import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ProfilesService } from '@icc/construction-elements/configurator';
import { ProfileSetsService } from '@icc/construction-elements/configurator';
import { ProfilesModalService } from './profiles-modal.service';
import { BrowserProfilesService } from './profiles.service';
import { BrowserProfileSetsService } from './profile-sets.service';
import { LippingColorsService } from './lipping-colors.service';
import { CasingsService } from './casings.service';

@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [],
    exports: [],
    providers: [
        BrowserProfilesService,
        { provide: ProfilesService, useExisting: BrowserProfilesService },
        BrowserProfileSetsService,
        { provide: ProfileSetsService, useExisting: BrowserProfileSetsService },
        ProfilesModalService,
        LippingColorsService,
        CasingsService
    ],
})
export class ProfilesModule {}
